import React, { useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import car from "../../assets/images/car5.jpg";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const RundläufeTransCirox = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  // Fallback for features to prevent .map error
  const features = Array.isArray(
    t("RundläufeTransCiroX.features", { returnObjects: true }),
  )
    ? t("RundläufeTransCiroX.features", { returnObjects: true })
    : [];

  return (
    <section className="service-section bg-light">
      <Container className="px-4 px-md-5 py-5">
        <Row className="mb-5 text-center" data-aos="fade-down">
          <Col>
            <h2 className="fw-bold text-orange">
              {t("RundläufeTransCiroX.title")}
            </h2>
          </Col>
        </Row>

        <Row className="align-items-center gy-4">
          <Col md={6} data-aos="fade-right">
            <h5 className="text-muted fw-semibold mb-3">
              {t("RundläufeTransCiroX.subtitle")}
            </h5>

            <ul className="text-muted fs-6 ps-3">
              {features.map((feature, index) => (
                <li key={index} className="mb-2">
                  <strong>{feature.title}</strong> {feature.description}
                </li>
              ))}
            </ul>

            <p className="text-muted fs-6 mt-3">
              {t("RundläufeTransCiroX.tips", { returnObjects: true }).map(
                (tip, index) => (
                  <li key={index} className="mb-2">
                    {tip}
                  </li>
                ),
              )}
            </p>

            <Button
              variant="warning"
              size="lg"
              className="bg-orange-500 text-white mt-3"
              onClick={() => navigate("/register/client")}
            >
              {t("RundläufeTransCiroX.button")}
            </Button>
          </Col>

          <Col md={6} data-aos="fade-left" className="text-center">
            <img
              src={car}
              alt="Spedition Transport"
              className="img-fluid rounded shadow img-car"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default RundläufeTransCirox;
